module.exports = __webpack_public_path__ + "img/pic7.963b1d16.png";